import gql from 'graphql-tag';

export default gql`
    fragment ProofEmail on ProofEmail {
        ID
        Created
        Message
        EmailSent
        ScheduledToSendEmail
        EmailApplicant
        EmailSupplier
        EmailOther
        OtherEmailAddress
        Approved
        ApprovedDate
        SentToRecipientEmailAddresses

        Attachments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
        
        EvidenceFiles {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;
